module.exports = __webpack_public_path__ + "static/media/team-graphic.f9dac19b.svg";